import { Moment, parseZone } from "moment";
import { DATE_FORMAT } from "../constants/date";

const parseMoment = (
  value: string,
  format: string = DATE_FORMAT
): Moment | null => {
  if (!value) {
    return null;
  }

  const parsedValue = parseZone(value.toString(), format);

  if (parsedValue.isValid()) {
    return parsedValue;
  }

  return null;
};

export default parseMoment;
